import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './dropdown.css';
import { Gesture, EventType as GestureEventType } from '../../touch.js';
import { ActionRunner } from '../../../common/actions.js';
import { EventHelper, EventType, removeClass, addClass, append, $, addDisposableListener } from '../../dom.js';
import { StandardKeyboardEvent } from '../../keyboardEvent.js';
import { Emitter } from '../../../common/event.js';
export var BaseDropdown = /*#__PURE__*/function (_ActionRunner) {
  _inherits(BaseDropdown, _ActionRunner);

  var _super = _createSuper(BaseDropdown);

  function BaseDropdown(container, options) {
    var _this;

    _classCallCheck(this, BaseDropdown);

    _this = _super.call(this);
    _this._onDidChangeVisibility = new Emitter();
    _this.onDidChangeVisibility = _this._onDidChangeVisibility.event;
    _this._element = append(container, $('.monaco-dropdown'));
    _this._label = append(_this._element, $('.dropdown-label'));
    var labelRenderer = options.labelRenderer;

    if (!labelRenderer) {
      labelRenderer = function labelRenderer(container) {
        container.textContent = options.label || '';
        return null;
      };
    }

    for (var _i = 0, _arr = [EventType.CLICK, EventType.MOUSE_DOWN, GestureEventType.Tap]; _i < _arr.length; _i++) {
      var event = _arr[_i];

      _this._register(addDisposableListener(_this.element, event, function (e) {
        return EventHelper.stop(e, true);
      })); // prevent default click behaviour to trigger

    }

    for (var _i2 = 0, _arr2 = [EventType.MOUSE_DOWN, GestureEventType.Tap]; _i2 < _arr2.length; _i2++) {
      var _event = _arr2[_i2];

      _this._register(addDisposableListener(_this._label, _event, function (e) {
        if (e instanceof MouseEvent && e.detail > 1) {
          return; // prevent multiple clicks to open multiple context menus (https://github.com/Microsoft/vscode/issues/41363)
        }

        if (_this.visible) {
          _this.hide();
        } else {
          _this.show();
        }
      }));
    }

    _this._register(addDisposableListener(_this._label, EventType.KEY_UP, function (e) {
      var event = new StandardKeyboardEvent(e);

      if (event.equals(3
      /* Enter */
      ) || event.equals(10
      /* Space */
      )) {
        EventHelper.stop(e, true); // https://github.com/Microsoft/vscode/issues/57997

        if (_this.visible) {
          _this.hide();
        } else {
          _this.show();
        }
      }
    }));

    var cleanupFn = labelRenderer(_this._label);

    if (cleanupFn) {
      _this._register(cleanupFn);
    }

    _this._register(Gesture.addTarget(_this._label));

    return _this;
  }

  _createClass(BaseDropdown, [{
    key: "element",
    get: function get() {
      return this._element;
    }
  }, {
    key: "show",
    value: function show() {
      if (!this.visible) {
        this.visible = true;

        this._onDidChangeVisibility.fire(true);
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.visible) {
        this.visible = false;

        this._onDidChangeVisibility.fire(false);
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(BaseDropdown.prototype), "dispose", this).call(this);

      this.hide();

      if (this.boxContainer) {
        this.boxContainer.remove();
        this.boxContainer = undefined;
      }

      if (this.contents) {
        this.contents.remove();
        this.contents = undefined;
      }

      if (this._label) {
        this._label.remove();

        this._label = undefined;
      }
    }
  }]);

  return BaseDropdown;
}(ActionRunner);
export var DropdownMenu = /*#__PURE__*/function (_BaseDropdown) {
  _inherits(DropdownMenu, _BaseDropdown);

  var _super2 = _createSuper(DropdownMenu);

  function DropdownMenu(container, options) {
    var _this2;

    _classCallCheck(this, DropdownMenu);

    _this2 = _super2.call(this, container, options);
    _this2._actions = [];
    _this2._contextMenuProvider = options.contextMenuProvider;
    _this2.actions = options.actions || [];
    _this2.actionProvider = options.actionProvider;
    _this2.menuClassName = options.menuClassName || '';
    _this2.menuAsChild = !!options.menuAsChild;
    return _this2;
  }

  _createClass(DropdownMenu, [{
    key: "menuOptions",
    get: function get() {
      return this._menuOptions;
    },
    set: function set(options) {
      this._menuOptions = options;
    }
  }, {
    key: "actions",
    get: function get() {
      if (this.actionProvider) {
        return this.actionProvider.getActions();
      }

      return this._actions;
    },
    set: function set(actions) {
      this._actions = actions;
    }
  }, {
    key: "show",
    value: function show() {
      var _this3 = this;

      _get(_getPrototypeOf(DropdownMenu.prototype), "show", this).call(this);

      addClass(this.element, 'active');

      this._contextMenuProvider.showContextMenu({
        getAnchor: function getAnchor() {
          return _this3.element;
        },
        getActions: function getActions() {
          return _this3.actions;
        },
        getActionsContext: function getActionsContext() {
          return _this3.menuOptions ? _this3.menuOptions.context : null;
        },
        getActionViewItem: function getActionViewItem(action) {
          return _this3.menuOptions && _this3.menuOptions.actionViewItemProvider ? _this3.menuOptions.actionViewItemProvider(action) : undefined;
        },
        getKeyBinding: function getKeyBinding(action) {
          return _this3.menuOptions && _this3.menuOptions.getKeyBinding ? _this3.menuOptions.getKeyBinding(action) : undefined;
        },
        getMenuClassName: function getMenuClassName() {
          return _this3.menuClassName;
        },
        onHide: function onHide() {
          return _this3.onHide();
        },
        actionRunner: this.menuOptions ? this.menuOptions.actionRunner : undefined,
        anchorAlignment: this.menuOptions ? this.menuOptions.anchorAlignment : 0
        /* LEFT */
        ,
        domForShadowRoot: this.menuAsChild ? this.element : undefined
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      _get(_getPrototypeOf(DropdownMenu.prototype), "hide", this).call(this);
    }
  }, {
    key: "onHide",
    value: function onHide() {
      this.hide();
      removeClass(this.element, 'active');
    }
  }]);

  return DropdownMenu;
}(BaseDropdown);